module.exports = __webpack_public_path__ + "img/widget_settings.e381405.svg";